/* CEJ的单元亲子活动页面 */
/*  Author: wanfengren */
/* create: 2018/09/25 */
<template>
<div class="flex-center flex-column mainbody">
  <!-- 通用介绍 -->
  <div class="header-panel">
    <div class="headertitle">{{ lang.resource_activity }}</div>
  </div>
  <div class="text-border-panel">
    <div class="maintext">
      <p v-html="lang.text_border_panel_tips"></p>
      <div v-if="Data.topic_level" style="text-indent: 2px;font-size: 15px">
        <div v-html="getProcessedHtml(lang['topic_level'], [[`{topic}`, Data.topic[0].topic]])"></div>
      </div></br>

      <div class="resource-list" id="topic_level">
        <li v-for="tl in Data.topic_level">
          <b> {{tl.topic_level}} : {{tl.desc}} </b>
        </li>
      </div>
      <span> <strong> {{ lang.child_activity }}</strong></span>
    </div>
  </div>

  <!-- 活动介绍 -->

  <div class="header-panel">
    <div class="headertitle">{{Data.activity}}</div>
  </div>
  <div class="text-border-panel">
    <div class="maintext">
      <div v-if="Data.target">
        <span class="orange-bold">{{ lang.activity }}</span><br>
        <div id="target" class="flex-row-left">{{Data.target}}</div></br>
      </div>

      <div v-if="Data.ability">
        <span class="orange-bold">{{ lang.ability }}</span><br>
        <div id="ability" class="flex-row-left">{{ lang.ability2 }}{{Data.ability.ability}}</div></br>
      </div>

      <div v-if="Data.activity_duration">
        <span class="orange-bold">{{ lang.activity_duration }}</span>
        <div id="activity_duration" class="flex-row-left">{{ lang.activity_duration_desc | multiReplace([['{activity_duration}', Data.activity_duration]]) }}</div></br>
      </div>

      <div v-if="Data.things">
        <span class="orange-bold">{{ lang.things }}</span>
        <div id="things" class="flex-row-left">{{Data.things}}</div></br>
      </div>

      <div class="section section-recommend" v-if="Data.key_word.length > 0">
        <span class="orange-bold">{{ lang.key_word_1 }}</span>
        <div id="key_word" class="flex-row-left">{{ lang.key_word_desc }}</div></br>
        <div class="resource-list" id="key_word">
          <span v-for="word in Data.key_word">
            <a :href="'/resource/word_v2/' + word.id + tailUrl" @click="word_learning(word.real_id)"><b> {{word.word_name}} </b><i class="cut-line"></i></a>
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- 活动步骤 -->
  <div class="header-panel" v-if="Data.detail_steps">
    <div class="headertitle">{{ lang.detail_steps }}</div>
  </div>
  <div class="text-border-panel" v-if="Data.detail_steps">
    <div class="maintext">
      <div class="flex-row-left" v-html="addDiv(Data.detail_steps)"></div>
    </div>
  </div>

</div>
</template>

<script>
import BaseVue from '@/components/BaseVue'

export default {
  name: 'ActivityTemplate',
  extends: BaseVue,
  data() {
    return {
      Data: {
        key_word: [],
        url_params: '',
        user_id: ''
      }
    }
  },
  computed: {
    tailUrl: function() {
      // return this.url_params === '' ? '' : '?' + this.url_params
      return this.url_params === '' ? '' : '?' + this.url_params
    }
  },
  created: async function() {
    // let data_id = this.$route.params.id
    // let url = this.APIHOST + 'activity/' + data_id + '?format=json'
    let data_id = this.$route.query.id
    this.user_id = this.$route.query.uid
    let url = this.GATEWAY_ORIGINAL + 'bigdata/cej_target/query_activity_info?id=' + data_id
    // this.url_params = this.$route.fullPath.split('?')[1]
    this.url_params = 'uid'+ this.$route.fullPath.split('uid')[1]
    // 增加单元知识点掌握报告埋点
    pindData.add_params({"t":"cms_activity.000001"});
    let value = '{"t":"cms_activity.000001","v":{"action":"PG_CMS_RESOURCE_ACTIVITY","userid":'+ this.user_id + '}}';
    __sdonclick(value);
    let that = this;
    await this.getLang();
    document.title = this.lang.ActivityTemplateTitle
    this.queryData(url, function(data) {
      that.Data = data
      // if (that.Data.video_link){
      //   that.Data.video_link = that.resetVideoSize(that.Data.video_link)
    })
  },
  methods: {
    getProcessedHtml(value, params) {
      let processedString = this.$options.filters.multiReplace(value, params);
      return processedString;
    },
    word_learning: function(id){
      //点击亲子活动中的核心词汇超链子页面学习
      let action = "CK_CMS_RESOURCE_ACTIVITY_WORD"
      pindData.pind_send( {"action": action,"id": id, "userid": this.user_id} );
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/resource/Activity.vue